/* eslint-disable no-restricted-globals */
export default () => {
  self.addEventListener("message", (event) => {
    if (!event) return;
    const { replacementAnalysisData, others, replacementPredictionData } =
      event.data.exportData;
    const { exportWorkerTransaltionString } = event.data.translations;
    const translatedRowData = event.data.translatedRowData;

    const dateFormatter = (date) => {
      if (date) {
        date = new Date(date);

        if (isNaN(date.getTime())) {
          return "Invalid Date";
        }
        const formattedDay = date.getDate().toString().padStart(2, "0");
        const formattedMonth = (date.getMonth() + 1)
          .toString()
          .padStart(2, "0");
        const formattedYear = date.getFullYear();

        return `${formattedDay}/${formattedMonth}/${formattedYear}`;
      } else return null;
    };

    const valueLanguageFormatter = (key, data) => {
      const value =
        translatedRowData && translatedRowData[key]
          ? translatedRowData[key][data]
          : "";
      return value;
    };

    const otherSheetData = others?.map((data, index) => {
      return {
        ...data,
        installation_date: dateFormatter(data.installation_date),
        warranty: data.warranty?.toString() === "true" ? "Yes" : "No",
      };
    });
    const replacementAnalysisSheetData = replacementAnalysisData?.map(
      (data, index) => {
        return {
          ...data,
          forecasted_date: dateFormatter(data.forecasted_date),
          trigger: valueLanguageFormatter("trigger", data.trigger),
          explanation: valueLanguageFormatter(
            "explanation",
            data.explanation
          ),
        };
      }
    );

    const dates = [
      // considering one parameters Dates as all of them have same
      ...replacementPredictionData.norm_salt_passage.historical_x,
      ...replacementPredictionData.norm_salt_passage.forecasted_x,
    ];
    const replacementPredictionSheetData = dates.map((date, index) => {
      const data = {
        date: date,
      };
      const normalizedCategories = Object.keys(replacementPredictionData);
      normalizedCategories.forEach((category) => {
        const ColumnValues = [
          ...replacementPredictionData[category].historical_y,
          ...replacementPredictionData[category].forecasted_y,
        ];
        data[category] = ColumnValues[index];
      });
      return data;
    });

    postMessage({
      replacementAnalysisSheetData,
      otherSheetData,
      replacementPredictionSheetData,
    });
  });
};
